import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  ElementRef,
  Renderer2,
  OnDestroy,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import {KanbanColumn} from '../../data/kanban-column';
import {Project} from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import {ProjectService} from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';
import {KanbanBoardService} from '../../data/kanban-board.service';
import {KanbanBoardStore} from '../../data/kanban-board.store';
import {KanbanBoardQuery} from '../../data/kanban-board.query';
import {CdkDragDrop, moveItemInArray, CdkDragMove} from '@angular/cdk/drag-drop';
import {trackEntityById} from 'projects/core/src/public-api';
import {debounceTime, filter, map} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBarRef, SimpleSnackBar, MatSnackBar} from '@angular/material/snack-bar';
import {Subject, Subscription} from 'rxjs';
import {KanbanCardComponent} from '../kanban-card/kanban-card.component';
import {takeUntil} from 'rxjs/operators';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';

@Component({
  selector: 'app-kanban-column',
  templateUrl: './kanban-column.component.html',
  styleUrls: ['./kanban-column.component.scss']
})
@RxJSUnsubscribe
export class KanbanColumnComponent implements OnInit, OnDestroy, OnChanges, RxJSUnsubscribable {
  protected scrollSubj = new Subject<number>();

  @Input()
  column: KanbanColumn

  @Input()
  device: string

  trackEntityById = trackEntityById;

  echoColumnId: number;
  echoPosId: number;
  echoProject: Project;

  activeSnackBar: MatSnackBarRef<SimpleSnackBar>

  mouseTimer: Subscription;

  tempCard: KanbanCardComponent;

  cdkStartDelayTime = 0;

  addSubj: Subscription;
  updateSubj: Subscription;
  removeSubj: Subscription;

  insertSubj: Subscription;
  moveSubj: Subscription;
  removeTileSubj: Subscription;

  countToShow = 15;
  abilityToLoad = true;
  columnLoadingSpinner = false;

  constructor(
    private snackBar: MatSnackBar,
    protected projectService: ProjectService,
    protected kanbanBoardService: KanbanBoardService,
    protected kanbanBoardStore: KanbanBoardStore,
    protected kanbanBoardQuery: KanbanBoardQuery,
    protected changeDetectorRef: ChangeDetectorRef,
    protected el: ElementRef,
    protected dialog: MatDialog,
    protected renderer: Renderer2
  ) {

  }


  ngOnInit() {
    if (this.device === 'isMobile' || this.device === 'isTablet') {
      this.cdkStartDelayTime = 200;
    }


    this.initProjectChangesListening()

    this.initTilesMoveListening()

    this.initScrollListening()
  }

  initTilesMoveListening() {
    this.insertSubj = this.kanbanBoardService
      .projectInsert
      .action
      .pipe(
        takeUntil(this.getUnsubFromAllSubs()),
        filter(event => event.columnId === this.column.id)
      )
      .subscribe(event => this.onProjectInserted(event.project, event.index))

    this.moveSubj = this.kanbanBoardService
      .projectMoveIn
      .action
      .pipe(
        takeUntil(this.getUnsubFromAllSubs()),
        filter(event => event.columnId === this.column.id)
      )
      .subscribe(event => this.onProjectMovedIn(event.projectId, event.indexFrom, event.indexTo))

    this.removeTileSubj = this.kanbanBoardService
      .projectRemove
      .action
      .pipe(
        takeUntil(this.getUnsubFromAllSubs()),
        filter(event => event.columnId === this.column.id),
        map(event => this.column.projectsList.findIndex(p => p.id === event.projectId)),
      )
      .subscribe(projectIndex => this.onProjectRemoved(projectIndex))
  }

  initProjectChangesListening() {
    type IndexUpdateInfo = [Project, number];
    this.addSubj = this.projectService
      .projectEmitter
      .add
      .pipe(
        takeUntil(this.getUnsubFromAllSubs()),
        map(event => event.entity),
        filter(project => project
          && project.card
          && project.card.list
          && project.card.list.id === this.column.id)
      )
      .subscribe(project => this.onProjectInserted(project, 0))

    this.updateSubj = this.projectService
      .projectEmitter
      .update
      .pipe(
        takeUntil(this.getUnsubFromAllSubs()),
        map(event => [event.entity, this.column.projectsList.findIndex(p => p.id === event.entity.id)] as IndexUpdateInfo),
        filter(([_, projectIndex]) => projectIndex >= 0)
      )
      .subscribe(([project, projectIndex]) => {
        this.onProjectUpdated(project, projectIndex)
      })

    this.removeSubj = this.projectService
      .projectEmitter
      .remove
      .pipe(
        takeUntil(this.getUnsubFromAllSubs()),
        map(event => this.column.projectsList.findIndex(p => p.id === event.entityId)),
        filter(projectIndex => projectIndex >= 0)
      )
      .subscribe(projectIndex => {
        this.onProjectRemoved(projectIndex)
      })
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  onDropIn(event: CdkDragDrop<KanbanColumn>) {
    // if (this.tempCard) {
    // 	this.tempCard.tilt(false);
    // }

    const previousColumn = event.previousContainer.data
    const currentColumn = event.container.data

    const project = previousColumn.projectsList[event.previousIndex]

    if (event.previousContainer !== event.container) {
      this.kanbanBoardService.projectRemove.emit({
        columnId: previousColumn.id,
        projectId: project.id
      });
      this.kanbanBoardService.projectInsert.emit({
        columnId: currentColumn.id,
        project,
        index: event.currentIndex
      });

      this.echoColumnId = previousColumn.id;
      this.echoPosId = event.currentIndex;
      this.echoProject = project;

    } else {
      this.kanbanBoardService.projectMoveIn.emit({
        columnId: currentColumn.id,
        projectId: project.id,
        indexFrom: event.previousIndex,
        indexTo: event.currentIndex
      });
    }

    this.moveCard(project.card.id, currentColumn.id, event.currentIndex)
  }

  onDragMoved(event: CdkDragMove<string>): void {
    this.kanbanBoardService.projectDragMove.emit(event);
  }

  cdkStarted() {

  }

  moveCard(cardId: number, columnid: number, pos: number) {
    this.kanbanBoardService
      .moveCard(cardId, columnid, pos)
      .subscribe(() => {
        },
        error => {
          if (error.message === 'Drawing not approved') {
            this.openSnackBar(error.message)
          } else if (error.status === 500 || error.status === 0) {
            this.openSnackBar('Server Error')
          } else {
            this.openSnackBar(error.message)
          }

          if (this.echoProject) {
            this.kanbanBoardService.projectRemove.emit({
              columnId: columnid,
              projectId: this.echoProject.id
            });
            this.kanbanBoardService.projectInsert.emit({
              columnId: this.echoColumnId,
              project: this.echoProject,
              index: this.echoPosId
            });
          }
        })
  }

  onProjectInserted(project: Project, index: number): void {
    const existingIndex = this.column.projectsList.findIndex(p => p.id === project.id);

    if (existingIndex >= 0) {
      // project already in this column

      if (existingIndex !== index) {
        // swap if it at another in place
        this.onProjectMovedIn(project.id, existingIndex, index);
      }
    } else {
      const newProjectsList = [...this.column.projectsList];
      newProjectsList.splice(index, 0, project);

      this.kanbanBoardStore.update(this.column.id, {
        ...this.column,
        count: this.column.count + 1,
        filteredCount: this.column.filteredCount + 1,
        projectsList: newProjectsList
      })

      this.column = this.kanbanBoardQuery.getEntity(this.column.id);

      if (this.changeDetectorRef) {
        this.changeDetectorRef.detectChanges();
      }
    }
  }

  onProjectMovedIn(projectId: number, indexFrom: number, indexTo: number): void {
    if (indexFrom < 0 || indexFrom >= this.column.projectsList.length) {
      console.error(`Wrong indexFrom ${indexFrom} for column ${this.column.name}`)
      return;
    }

    if (indexTo < 0 || indexTo >= this.column.projectsList.length) {
      console.error(`Wrong indexTo ${indexTo} for column ${this.column.name}`)
      return;
    }

    if (this.column.projectsList[indexFrom].id !== projectId) {
      console.error(`Project id ${projectId} mismatch on moving card in column ${this.column.name}`)
      return;
    }

    const newProjectsList = [...this.column.projectsList];

    moveItemInArray(newProjectsList, indexFrom, indexTo);

    this.kanbanBoardStore.update(this.column.id, {
      ...this.column,
      count: this.column.count,
      filteredCount: this.column.filteredCount,
      projectsList: newProjectsList
    })

    this.column = this.kanbanBoardQuery.getEntity(this.column.id);

    if (this.changeDetectorRef) {
      this.changeDetectorRef.detectChanges();
    }
  }

  onProjectUpdated(project: Project, projectIndex: number): void {

    const newProjectsList = [...this.column.projectsList];
    newProjectsList[projectIndex] = project;

    this.kanbanBoardStore.update(this.column.id, {
      ...this.column,
      projectsList: newProjectsList
    })
  }

  onProjectRemoved(projectIndex: number): void {
    const newProjectsList = [...this.column.projectsList];

    newProjectsList.splice(projectIndex, 1);

    this.kanbanBoardStore.update(this.column.id, {
      ...this.column,
      count: this.column.count - 1,
      filteredCount: this.column.filteredCount - 1,
      projectsList: newProjectsList
    })

    this.column = this.kanbanBoardQuery.getEntity(this.column.id);

    if (this.changeDetectorRef) {
      this.changeDetectorRef.detectChanges();
    }
  }

  openSnackBar(message: string, duration: number = null) {
    if (this.activeSnackBar) {
      this.activeSnackBar.dismiss();
    }
    duration = (duration !== null
        ? duration
        : Math.min(2000 + message.length * 50, 15000)) as number;
    // console.log(message, 'duration', duration)

    this.activeSnackBar = this.snackBar.open(message, '', {
      duration,
      panelClass: 'drag-error-snackbar',
      verticalPosition: 'top',
    });
  }

  ngOnDestroy() {
    this.changeDetectorRef = null;

    if (this.addSubj) {
      this.addSubj.unsubscribe()
    }
    if (this.updateSubj) {
      this.updateSubj.unsubscribe()
    }
    if (this.removeSubj) {
      this.removeSubj.unsubscribe()
    }

    if (this.insertSubj) {
      this.insertSubj.unsubscribe()
    }
    if (this.moveSubj) {
      this.moveSubj.unsubscribe()
    }
    if (this.removeTileSubj) {
      this.removeTileSubj.unsubscribe()
    }
  }

  mouseLeave() {
    if (this.mouseTimer) {
      this.mouseTimer.unsubscribe();
      this.mouseTimer = null;
    }
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }

  showMoreProjs() {
    this.abilityToLoad = false;

    this.kanbanBoardQuery.filter$.pipe(
      takeUntil(this.getUnsubFromAllSubs())
    ).subscribe((colFilter => {
      const page = Math.floor(this.column.projectsList.length / this.countToShow)
      this.kanbanBoardService.getProjectsFromColumn(this.column.id, page, this.countToShow, colFilter).subscribe((res => {

        if (res.length > 0) {
          const newProjectsList = [...this.column.projectsList];
          newProjectsList.push(...res)

          this.kanbanBoardStore.update(this.column.id, {
            ...this.column,
            projectsList: newProjectsList
          })
          this.abilityToLoad = newProjectsList.length < this.column.filteredCount;

        } else {
          this.abilityToLoad = false;
        }
        this.columnLoadingSpinner = false;
        this.changeDetectorRef.detectChanges()
      }))
    }))
  }

  initScrollListening() {
    this.scrollSubj
      .pipe(
        takeUntil(this.getUnsubFromAllSubs()),
        debounceTime(200),
      )
      .subscribe(() => {
        const cointainer = (this.el.nativeElement.getElementsByClassName('tasks-container') as HTMLElement)[0]
        const columnSize = cointainer.clientHeight
        const columnHeightSize = cointainer.scrollHeight
        const scrollPos = cointainer.scrollTop

        if ((columnHeightSize - scrollPos - columnSize) < 150 && !this.columnLoadingSpinner) {
          this.columnLoadingSpinner = true;
          this.changeDetectorRef.detectChanges()

          this.showMoreProjs()
        }
      })

  }

  onScroll() {
    if ((this.column.projectsList.length < this.column.filteredCount) && this.abilityToLoad) {
      this.scrollSubj.next()
    }
  }
}
